import React, { useState, useEffect } from 'react';
import {  Col, Row } from 'react-bootstrap';
import client from "../../services/Api";
import { useParams } from 'react-router-dom'
import moment from 'moment';
import DataTable from 'react-data-table-component';
import { ModalManager } from 'react-dynamic-modal/lib/Modal';
import DeviceNotificationDetails from './DeviceNotificationDetails'

function DeviceNotification({ location, history, params }) {
    const [notifications, setNotifications] = useState([])
    const { mac } = useParams();


    //datatable config
    const columns = [
        {
            name: 'Data da ocorrência',
            selector: 'date',
            format: row => moment.utc(row.date).local().format('DD/MM/YYYY HH:mm:ss'),
            sortable: true,
            width: '20%',
        },
        {
            name: 'Tipo do alarme',
            selector: 'type_formatted',
            sortable: true,
            width: '15%',
        },
        {
            name: 'Mensagem',
            selector: 'message',
            sortable: true,
            width: '40%',
        },
        {
            name: 'Temperatura (Min - Max)',
            selector: 'temperature_formatted',
            sortable: true,
            width: '10%',
        },
        {
            name: 'Umidade (Min - Max)',
            selector: 'humidity_formatted',
            sortable: true,
            width: '10%',
        },
        {
            name: 'Reconhecido?',
            selector: 'acknowledge_formatted',
            sortable: true,
            width: '10%',
        },
        {
            name: 'Ativo?',
            selector: 'active_formatted',
            sortable: true,
            width: '5%',
        },
        {
            name: 'Ações',
            cell: (row) =>
              <Row>
                  <Col>
                  <div className="actions">
                    <button className="add-beacon edit-beacon" onClick={() =>
                      openAlertDetailsModal(row)
                    }>
                      Detalhes do alarme
                        </button>
                  </div>
                </Col>
              </Row>
            ,
            width: '20%',
          },
        
    ];

    useEffect(() => {
        getBeaconNotifications()
    }, []);

    async function getBeaconNotifications() {
        try {
            const response = await client.get(`/api/beacon-device/${mac}/notifications`);
            setNotifications(response.data)
            return response;
        } catch (e) {
            console.log(e);
        }
        return null;
    }

    return (
        <div className="beacon-table">
            <DataTable
                columns={columns}
                data={notifications}
                noDataComponent={
                    <span>Nada encontrado.</span>
                }
                pagination={true}
            />
        </div>
    );

    function openAlertDetailsModal(row)
    {
        ModalManager.open(<DeviceNotificationDetails data={row} />)
    }

}

export default DeviceNotification;